class DeviceCursorManager {
  static BREAKPOINTS = {
    DESKTOP: 1280,
    TABLET_MIN: 768,
    TABLET_MAX: 1280
  };

  constructor() {
    this.IS_DESKTOP = false;
    this.IS_TABLET = false;
    this.IS_MOBILE = false;

    this.tooltip = null;
    this.followMouse = null;
    this.isHoveringTarget = false;
    this.lastX = 0;
    this.lastY = 0;
    this.lastCall = 0;
    this.throttleDelay = 40;

    this.init();
  }

  init() {
    this.updateDeviceVars();
    this.setupEventListeners();
    this.updateCursorBasedOnDevice();
  }

  setupEventListeners() {
    window.addEventListener('resize', () => {
      this.updateDeviceVars();
      this.updateCursorBasedOnDevice();
    });
  }

  updateDeviceVars() {
    const w = window.innerWidth;
    this.IS_DESKTOP = w > DeviceCursorManager.BREAKPOINTS.DESKTOP;
    this.IS_TABLET = w <= DeviceCursorManager.BREAKPOINTS.TABLET_MAX &&
      w >= DeviceCursorManager.BREAKPOINTS.TABLET_MIN;
    this.IS_MOBILE = w < DeviceCursorManager.BREAKPOINTS.TABLET_MIN;
  }

  updateCursorBasedOnDevice() {
    if (this.IS_DESKTOP) {
      this.setCursor();
    } else {
      this.removeCursor();
    }
  }

  createTooltip() {
    this.tooltip = document.createElement('div');
    this.tooltip.classList.add('tooltip');
    document.body.append(this.tooltip);

    // initial position
    gsap.set(this.tooltip, { x: 100, y: 100 });
  }

  handleMouseMove = (e) => {
    const now = Date.now();
    if (now - this.lastCall < this.throttleDelay) return;
    this.lastCall = now;

    if (!this.isHoveringTarget) {
      this.lastX = e.clientX;
      this.lastY = e.clientY;
      gsap.to(this.tooltip, {
        x: e.clientX + 75,
        y: e.clientY + 75,
        duration: 0.7,
        ease: 'power2.out'
      });
    }
  };

  handleButtonMouseEnter = (btn) => () => {
    this.isHoveringTarget = true;
    const rect = btn.getBoundingClientRect();
    const centerX = rect.left + rect.width / 2;
    const centerY = rect.top + rect.height / 2;

    gsap.to(this.tooltip, {
      x: centerX,
      y: centerY,
      duration: 0.4,
      ease: 'back.out(1.7)',
      scale: 1.2,
    });

    this.tooltip.classList.add('magnet');
  };

  handleButtonMouseLeave = () => {
    this.isHoveringTarget = false;
    gsap.killTweensOf(this.tooltip);

    gsap.to(this.tooltip, {
      x: this.lastX,
      y: this.lastY,
      duration: 0.5,
      scale: 1,
      ease: 'sine.out'
    });

    this.tooltip.classList.remove('magnet');
  };

  setCursor() {
    const targetButtons = document.querySelectorAll('.btn-magnet');

    if (!targetButtons.length) return;

    if (!this.tooltip) {
      this.createTooltip();
    }

    targetButtons.forEach(btn => {
      btn.addEventListener('mouseenter', this.handleButtonMouseEnter(btn));
      btn.addEventListener('mouseleave', this.handleButtonMouseLeave);
    });

    if (!window._cursorMouseMoveAdded) {
      this.followMouse = this.handleMouseMove;
      document.addEventListener('mousemove', this.followMouse);
      window._cursorMouseMoveAdded = true;
    }
  }

  removeCursor() {
    if (!this.tooltip) return;

    // Remove all event listeners from buttons
    const targetButtons = document.querySelectorAll('.btn-magnet');
    targetButtons.forEach(btn => {
      btn.removeEventListener('mouseenter', this.handleButtonMouseEnter(btn));
      btn.removeEventListener('mouseleave', this.handleButtonMouseLeave);
    });

    this.tooltip.remove();
    this.tooltip = null;

    if (window._cursorMouseMoveAdded && this.followMouse) {
      document.removeEventListener('mousemove', this.followMouse);
      window._cursorMouseMoveAdded = false;
    }

    this.isHoveringTarget = false;
  }

  // Public method to manually update cursor (if needed)
  refresh() {
    this.updateDeviceVars();
    this.updateCursorBasedOnDevice();
  }
}

// Usage:
new DeviceCursorManager();